import { FeeDataAPI } from "../common/lib/API/FeeDataAPI";
import { ApplicationDataAPI } from "../common/lib/API/ApplicationDataAPI";

const FeesRepo = {
    async getApplicationFeesById(app) {
        let fees = await ApplicationDataAPI.getApplicationFeesById(app.id, app.broker_id);
        return fees;
    },
    async getApplicationStateSalesTaxById(app) {
        let salesTax = await ApplicationDataAPI.getApplicationStateSalesTaxById(app.id, app.broker_id)
        return salesTax;
    },
    async addFee(data) {
        const response = await FeeDataAPI.addFee(data);
        return response
    },
    async updateFee(data) {
        await FeeDataAPI.updateFee(data);
        return;
    },
    async deleteFee(feeId) {
        await FeeDataAPI.deleteFee(feeId);
        return;
    },
}

export default FeesRepo;